export const CountryContainer = {
  width: '100%',
  maxWidth: 1200,
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const FormRow = {
  display: 'flex',
  flexDirection: {xs: 'column', sm: 'row'},
  gap: '16px',
  width: '100%',
};

export const ActionsRow = {
  display: 'flex',
  gap: '8px',
  width: '100%',
  justifyContent: 'flex-end',
};

export const ContentRowHeader = {
  display: 'flex',
  flexDirection: {xs: 'column', sm: 'row'},
  justifyContent: 'space-between',
  alignItems: {xs: 'flex-start', sm: 'center'},
  gap: 1,
  width: '100%',
};
